import { render, staticRenderFns } from "./PricingToggler.vue?vue&type=template&id=32610846&"
import script from "./PricingToggler.vue?vue&type=script&lang=js&"
export * from "./PricingToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports